import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'
import EmailSection from '../Home/HomeSections/EmailSection'
import Lorem from '../Home/HomeSections/Lorem'
import ChooseYourPlan from './PricingSections/ChooseYourPlan'
import FAQs from './PricingSections/FAQs'
import Testimonials from '../Home/HomeSections/Testimonials'

export default function Pricing() {
    return (
        <div>
            <Header />
            <ChooseYourPlan/>
            <EmailSection/>
            <Testimonials/>
            <FAQs/>
            <Lorem/>
            <Footer />
        </div>
    )
}
